import { render, staticRenderFns, recyclableRender, components } from "./footTabbar.vue?vue&type=template&id=6a042adc&"
var renderjs
import script from "./footTabbar.vue?vue&type=script&lang=js&"
export * from "./footTabbar.vue?vue&type=script&lang=js&"
import style0 from "./footTabbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/tabbar/footTabbar.vue"
export default component.exports